import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row, Table } from 'react-bootstrap';
import XIcon from '../lib/XIcon';
import { XRPSCAN_API_URL } from '../../config';
import { handleResponse } from '../common/Helpers';
import AccountTag from '../lib/AccountTag';
import XBadge from '../lib/XBadge';
import Money from '../lib/Money';
import Skeleton from 'react-loading-skeleton';

const TransactionMutation = (props) => {
    const { hash } = props;
    const [ mutations, setMutations ] = useState({});

    useEffect(() => {
        fetchMutations(hash);
    }, [hash]);

    const fetchMutations = (hash) => {
        fetch(`${XRPSCAN_API_URL}/tx/${hash}/mutations`)
        .then(handleResponse)
        .then(data => {
            setMutations(data);
        })
        .catch(error => {
            setMutations({});
        })
        .finally(() => {
        });
    }

    const getAmount = (account, index) => {
        return (mutations?.allBalanceChanges?.[account]?.[index]);
    }

    const mutationStyle = (account, index) => {
        const Amount = getAmount(account, index);
        return (Number(Amount?.value) >= 0) ? "success" : "warning";
    }

    const isPositiveMutation = (account, index) => {
        const Amount = getAmount(account, index);
        return (Number(Amount?.value) >= 0);
    }

    const isCreditOrDebit = (account, index) => {
        return isPositiveMutation(account, index) ? <>CREDIT:</> : <>DEBIT:</>
    }

    const getMutationAmountTag = (account, index) => {
        const Amount = getAmount(account, index);
        if (Amount?.value && Amount?.currency) {
            return <Money currency={Amount?.currency} issuer={Amount?.counterparty} value={Amount?.value} min={0} max={6}/>
        } else {
            return <></>;
        }
    }

    const getMutation = (account, index) => {
        return (
        <XBadge variant={mutationStyle(account, index)}>
            <span className='mr-2'>{ isCreditOrDebit(account, index) }</span>
            {getMutationAmountTag(account, index)}
        </XBadge>);
    }

    return (
        <Card>
            <Card.Body>
                <Card.Title>
                    <XIcon icon='swap-arrows' />
                    <span className="ml-2">Balance changes</span>
                </Card.Title>
                <Row>
                    <Col xs={12} md={12}>
                        <Table responsive>
                            <thead>
                                <tr className='text-nowrap'>
                                    <th className="text-left">#</th>
                                    <th className="text-left">Type</th>
                                    <th className="text-left">Affected account</th>
                                    <th className="text-center" colSpan={3}>Balance changes</th>
                                </tr>
                            </thead>
                            <tbody>
                            {!mutations?.allBalanceChanges &&
                            <>
                                <tr><td className="border-top-0" colSpan={6}><Skeleton /></td></tr>
                                <tr><td className="border-top-0" colSpan={6}><Skeleton /></td></tr>
                            </>
                            }

                            {mutations?.allBalanceChanges && Object.keys(mutations?.allBalanceChanges).map((account, index) =>
                            <tr key={index} className='text-nowrap'>
                                <td>
                                    {index+1}
                                </td>
                                <td>
                                    <XBadge variant="primary">{mutations?.type}</XBadge>
                                </td>
                                <td>
                                    <AccountTag link>{account}</AccountTag>
                                    {mutations?.self?.account === account &&
                                    <XBadge variant="secondary" className="ml-1">FEE PAYER</XBadge>
                                    }
                                </td>
                                <td className='text-right'>
                                    { getAmount(account, 0) && getMutation(account, 0) }
                                </td>
                                <td className="text-right">
                                    { getAmount(account, 1) && getMutation(account, 1) }
                                </td>
                                <td className="text-right">
                                    { getAmount(account, 2) && getMutation(account, 2) }
                                </td>
                            </tr>
                            )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

TransactionMutation.propTypes = {
    hash: PropTypes.string.isRequired,
}

export default TransactionMutation;